import React from 'react';
import styles from './Header.module.css';
import logoEfigas from '../../assets/logo_efigas.svg';

function Header() {
  return (
    <header className={styles.header}>
      <img src={logoEfigas} alt="Logo Efigas" className={styles.logo} />
    </header>
  );
}

export default Header;